import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import { ScribbleBar } from '@atlassian/guard-redaction-ui/scribble';

const redactionBarStyles = xcss({
	display: 'inline-flex',
	aspectRatio: '3.4/1',
	height: '1lh',
	'@supports not (height: 1lh)': {
		height: '1.5em',
	},
	backgroundColor: 'color.background.neutral.bold.pressed',
	verticalAlign: 'middle',
	position: 'relative',
	// Redacted content must not be selectable/copyable.
	userSelect: 'none',
});

export function RedactionMarker(): React.JSX.Element {
	if (fg('platform_editor_redaction_shared_scribble')) {
		return <ScribbleBar background="light" />;
	}
	return <Box as="span" xcss={redactionBarStyles} />;
}
